import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { RazlogPrestankaRo } from './razlog-prestanka-ro';

@Component({
  selector: 'yt-razlog-prestanka-ro',
  templateUrl: './razlog-prestanka-ro.component.html'
})
export class RazlogPrestankaRoComponent extends BaseModalContainer<RazlogPrestankaRo> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<RazlogPrestankaRo>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
  }

  ngOnInit() {
  }

}
